import { createContext, useContext } from "react"
import { UseFormReturn } from "react-hook-form"
import * as z from "zod"

export const formSchema = z.object({
  start_time: z.date(),
  start_time_input: z.string(),
  end_time: z.date().optional(),
  end_time_input: z.string().optional(),
  has_woken_up: z.enum(['yes', 'no', 'unknown']).default('unknown'),
  location_id: z.string().min(1, "Please select a location"),
  environment_id: z.string().min(1, "Please select an environment"),
  onset_method_id: z.string().min(1, "Please select an onset method"),
  sound_id: z.string().min(1, "Please select a sound"),
  sound_level_id: z.string().min(1, "Please select a sound level"),
  restfulness_id: z.string().optional(),
  signs_of_sleep_debt: z.boolean(),
  notes: z.string().optional(),
  childId: z.string().optional(),
  caregiverId: z.string().optional(),
  confirmed: z.boolean().optional(),
  status: z.enum(['in_progress', 'complete']).default('in_progress')
}).refine(
  (data) => {
    // Only validate end_time if baby has woken up
    if (data.has_woken_up === 'yes' && data.end_time) {
      return data.end_time > data.start_time;
    }
    return true;
  },
  {
    message: "Wake up time must be after sleep time",
    path: ["end_time"]
  }
)

export type SleepFormData = z.infer<typeof formSchema>

const SleepFormContext = createContext<UseFormReturn<SleepFormData> | null>(null)

export function useSleepForm() {
  const context = useContext(SleepFormContext)
  if (!context) {
    throw new Error("useSleepForm must be used within a SleepFormProvider")
  }
  return context
}

export const SleepFormProvider = SleepFormContext.Provider
